import React from "react";
import { connect } from "react-redux";
import { getPODetails, getPOLineItems, getPOLineItem } from "../Actions/POViewAPI";
import { addMMPLShortClosedSearchlist  } from "../Actions/MMPLDashboardAPI";
import { Button, Popover, PopoverHeader, PopoverBody, UncontrolledPopover } from "reactstrap";
import Moment from "moment";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import { DownloadDocument } from "../Actions/CommonAPI";
import { toast, ToastContainer } from "react-toastify";

class POView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded:false,
            isChecked: false,
            IHMYes: false,
            IHMNo: false,
            keywords: "",
            PoConfirmation: {
                shipId: 0,
                purchaseOrderId: 0,
                poLineItemId: 0,
                ihmPresence: false,
                collectMdocSdoc: false,
                notApplicable: false,
                addKeyWords: false,
                keyword: [],
                modifiedBy: "",
                AddAll: false
            },
            EditAll: false,
            taskType: "purchaseorders"
        };
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.checkBoxClick = this.checkBoxClick.bind(this);
        this.ConfirmPO = this.ConfirmPO.bind(this);
    }

    componentDidMount() {
        this.state.isLoaded=false;
        const { dispatch, match, history } = this.props;
        const { params } = match;
        const { shipid, poid } = params;
        dispatch({ type: 'SubBannerTitle', data: "Purchase Orders" });
        if (shipid !== "" && poid !== "") {
            let url = `${API.PODetail}?poId=${poid}`;
            axios.get(url)
            .then((response) => {
               // history.location.pathname == `/Home/POViewRead/${shipid}/${poid}/${type}` ? dispatch(getPOLineItems(poid, type)) : dispatch(getPOLineItem(poid));
               dispatch(getPOLineItem(poid));
               dispatch({
                    type: "getPODetailsSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getPODetailsFailure",
                    error: "ERROR"
                })
            })
            // dispatch(getPODetails(poid));
            // dispatch(getPOLineItem(poid));
        }
        if (history.location.pathname == `/Home/POViewEdit/${shipid}/${poid}`) {
            this.props.dispatch({ type: "EditPOView", data: true });
        }
        dispatch({ type: 'getPOLineItemsSuccess', data: null })
    }

    handleRadioButtonChange(e) {

        let nodeName = e.target.name;
        if (nodeName === "IHMYes") {
            this.state.PoConfirmation.notApplicable = false;
            this.state.PoConfirmation.collectMdocSdoc = false;
            this.state.PoConfirmation.ihmPresence = true;
            this.setState({
                IHMYes: true,
                IHMNo: false,
            });
        } else if (nodeName === "IHMNo") {
            this.state.PoConfirmation.notApplicable = false;
            this.state.PoConfirmation.collectMdocSdoc = false;
            this.state.PoConfirmation.ihmPresence = false;
            this.setState({
                IHMYes: false,
                IHMNo: true,
            });
        } else if (nodeName === "notApplicable") {
            this.state.PoConfirmation.notApplicable = true;
            this.state.PoConfirmation.collectMdocSdoc = false;
            this.setState({
                IHMYes: false,
                IHMNo: false,
            });
        } else if (nodeName === "collectMdocSdoc") {
            this.state.PoConfirmation.notApplicable = false;
            this.state.PoConfirmation.collectMdocSdoc = true;
            this.setState({
                IHMYes: false,
                IHMNo: false,
            })
        }
    }

    handleInputChange(e) {

        // this.state.keywords=e.target.value;
        this.state.PoConfirmation.keyword = [e.target.value];
        this.setState({ keywords: e.target.value });
    }

    checkBoxClick(e) {

        let checked = this.state.isChecked;
        if (e.target.checked) {
            checked = true;
        }
        else {
            checked = false;
        }
        this.state.PoConfirmation.addKeyWords = checked;
        this.setState({});
    }

    ConfirmPO(item) {
        const { dispatch, match } = this.props;
        confirmAlert({
            message: 'Are you sure want to add?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        this.state.PoConfirmation.AddAll=false
                        let url = `${API.AddAll}?PoLineItemId=${item.poLineItemId}&PurchaseOrderId=${item.purchaseOrderId}&AddAll=${this.state.PoConfirmation.AddAll}`;
                        axios.put(url)
                            .then((response) => {
                                dispatch(getPOLineItems(match.params.poid, this.state.taskType));
                                toast.success('Po Added successfully.', {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                dispatch({
                                    type: "POAddedSuccess",
                                    data: response.data
                                })
                            })
                            .catch((error) => {
                                dispatch({
                                    type: "POAddedFailure",
                                    error: "ERROR"
                                })
                            })

                        //  dispatch(UpdatePOConfirmation(this.state.PoConfirmation));

                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });

    }

    confirmAll = (item) => {
        const { dispatch, match } = this.props;
        confirmAlert({
            message: 'Are you sure want to add?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        this.state.PoConfirmation.AddAll = true;
                        let url = `${API.AddAll}?PurchaseOrderId=${item.purchaseOrderId}&AddAll=${this.state.PoConfirmation.AddAll}`;
                        axios.put(url)
                            .then((response) => {
                                dispatch(getPOLineItems(match.params.poid, this.state.taskType));
                                toast.success('Po Added successfully.', {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                dispatch({
                                    type: "POAddedSuccess",
                                    data: response.data
                                })
                            })
                            .catch((error) => {
                                dispatch({
                                    type: "POAddedFailure",
                                    error: "ERROR"
                                })
                            })
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }


    shortCloseAll = (item) => {
        const { dispatch, match } = this.props;
        confirmAlert({
            message: 'Are you sure want to Short Close ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        let url = `${API.ShortClosed}`;
                        let data = {
                            purchaseOrderId: item.purchaseOrderId,
                            isShortClosed: true
                        }
                        axios.put(url, data)
                            .then((response) => {
                                dispatch(getPOLineItems(match.params.poid, this.state.taskType));
                                toast.success('Short Closed successfully.', {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                dispatch({
                                    type: "POShortCloseSuccess",
                                    data: response.data
                                })
                            })
                            .catch((error) => {
                                dispatch({
                                    type: "POShortCloseFailure",
                                    error: "ERROR"
                                })
                            })
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }


    shortClose = (item) => {
        const { dispatch, match } = this.props;
        confirmAlert({
            message: 'Are you sure want to Short Close ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        let url = `${API.ShortClosed}`;
                        let data = {
                            purchaseOrderId: item.purchaseOrderId,
                            poLineItemId: item.poLineItemId,
                            isShortClosed: true
                        }
                        axios.put(url, data)
                            .then((response) => {
                                dispatch(getPOLineItems(match.params.poid, this.state.taskType));
                                toast.success('Short Closed successfully.', {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                dispatch({
                                    type: "LineItemShortCloseSuccess",
                                    data: response.data
                                })
                            })
                            .catch((error) => {
                                dispatch({
                                    type: "LineItemShortCloseFailure",
                                    error: "ERROR"
                                })
                            })
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }

    hideSidePanel = () => {
        this.props.history.goBack();
    }

    render() {
        const { PODetail, editPOView, POLineItems } = this.props;

        return (
            <div className="full-height px-4 pb-4">
                <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
                    onClick={() => this.hideSidePanel()}
                >
                    &larr; Back
                        </button>
                <div className="row mt-3">
                    <div className="col-lg-12">
                        <div className="panel-box">
                            <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <h5 className="card-title ml-2 my-2" style={{ color: "092a51" }}>
                                                {PODetail ? PODetail.poNo : ""}
                                            </h5>
                                        </div>
                                        <div className="col-sm-3">
                                            <h5 className="card-title ml-2 my-2" style={{ color: "092a51" }}>
                                                {PODetail ? PODetail.prNo : ""}
                                            </h5>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="px-4 py-2">
                                <div className="resource-list-auth-date">
                                    <div className="row">
                                        <div className="col-md-12 ">
                                            <div className="row">
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>PO Date : </strong>
                                                        <span className="italicFont">{PODetail ? Moment(new Date(Date.parse(PODetail.poDate))).format('DD MMM YYYY') : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>Make : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {PODetail ? PODetail.make : ""}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>Model : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {PODetail ? PODetail.model : ""}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>IHM Presense : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont mr-3">
                                                            {PODetail && PODetail.ihmPresence ? "Yes" : "No"}
                                                        </span>

                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>Supplier Name : </strong>
                                                        <span className="italicFont ">{PODetail ? PODetail.supplierName : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1" style={{ wordBreak: "break-all" }}>
                                                    <span>
                                                        <strong>Supplier Email : </strong>
                                                        <span className="italicFont">{PODetail ? PODetail.supplierEmail : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>PO Description : </strong>
                                                        <span className="italicFont ">{PODetail ? PODetail.poDescription : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <div className="row">
                                                        <div className=" col-md-12 py-1">
                                                            <button class="btn btn-secondary btn-xs btn-conf-edit" data-confirmation="cancel" style={{ width: "180px" }} id='EditAll' onClick={() => this.confirmAll(PODetail)}>
                                                                <i class="glyphicon glyphicon-remove"></i> Add All to PO Validation
                                                    </button>
                                                        </div>
                                                        <div className="col-md-10 ml-4">
                                                            <button class="btn btn-danger btn-xs btn-conf-edit mt-2" data-confirmation="confirm" style={{ width: "120px" }} onClick={() => this.shortCloseAll(PODetail)}>
                                                                <i class="glyphicon glyphicon-ok"></i> Short Close
                                                    </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-lg-12">
                        <div className="card MM-card-header" style={{ backgroundColor: "white" }}>
                            <div className="card-body">
                                <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                    Line Items
                                </h5>
                            </div>
                        </div>
                        <div className="p-0">
                            <div className="row">
                                <div className="col-md-12">
                                    {this.renderLineItemCard()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderLineItemCard() {
        const { editPOView, POLineItems ,noPoLineItems} = this.props;
        if(noPoLineItems == true){
           this.state.isLoaded = noPoLineItems;
        }
        return POLineItems && POLineItems.length
            ? POLineItems.map((item, index) => {
                return (
                    <>
                        <div className="card" style={{ overflow: "hidden", position: "relative", marginBottom: '5px' }}>
                            {/* <div className="arrow-left-red"></div> */}
                            {item.ihmPresence == "Yes" || item.ihmPresence ? (
                                <div className="arrow-left-red"></div>
                            ) : (
                                    <div className="arrow-left-green"></div>
                                )}
                            <div className="px-4 py-2">
                                <div className="resource-list-auth-date">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>Serial No : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.poLineItemId}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-2 py-1">
                                                    <span>
                                                        <strong>Qty : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.quantity}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>Unit : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.units}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-2 py-1">
                                                    <span>
                                                        <strong>Part No/Drawing No : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.partNo}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-2 py-1">
                                                    <span>
                                                        <strong>IHM Presense : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont mr-3">
                                                            {item.ihmPresence ? "Yes" : "No"}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>SDoC : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.sdocAttachmentName}
                                                        </span>
                                                        {item.sdocAttachmentName ?
                                                            <i class="fa fa-download click ml-1" onClick={() => this.downloadAttachment(item.sdocAttachmentName, item.sdocAttachmentGuid)}></i>
                                                            : null}
                                                    </span>
                                                </div>
                                                <div className="col-md-2 py-1">
                                                    <span>
                                                        <strong>MD : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.mdocAttachmentName}
                                                        </span>
                                                        {item.mdocAttachmentName ?
                                                            <i class="fa fa-download click ml-1" onClick={() => this.downloadAttachment(item.mdocAttachmentName, item.mdocAttachmentGuid)}></i>
                                                            : null}
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                <span>
                                                        <strong>Current Status : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.currentStatus}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-4 py-1"></div>
                                                <div className="col-md-5 py-1">
                                                <span>
                                                        <strong>Item Description : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.itemDescription}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-5 py-1">
                                                    <span>
                                                        <strong>Comments : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.comments}
                                                        </span>
                                                    </span>
                                                </div>
                                                {/* <div className="col-md-6 py-1"></div> */}
                                                <div className="col-md-2 py-1">
                                                <div className="row">
                                                    <div className=" col-md-12 py-1">
                                                        <button class="btn btn-secondary btn-xs btn-conf-edit" data-confirmation="cancel" style={{ width: "160px", }} id='EditAll' onClick={() => this.ConfirmPO(item)}>
                                                            <i class="glyphicon glyphicon-remove"></i> Add  to PO Validation
                                                        </button>
                                                    </div>
                                                    <div className="col-md-10 ml-4">
                                                        <button class="btn btn-danger btn-xs btn-conf-edit mt-2" data-confirmation="confirm" style={{ width: "120px" }} onClick={() => this.shortClose(item)}>
                                                            <i class="glyphicon glyphicon-ok"></i> Short Close
                                                        </button>
                                                    </div>
                                                </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }) : this.state.isLoaded == true?
            <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                <div class="container">
                    <h6 className="resource-list-title no-item-card">
                        No Items
                </h6>
                </div>
            </div>
            : null;
    }
    downloadAttachment = (FileName, Guid) => {
        const { dispatch } = this.props;
        dispatch(DownloadDocument(FileName, Guid));
    }

}

function mapStateToProps(state) {
    return {
        //BY BALU MOORTHI
        PODetail: state.POViewReducer.PODetail,
        POLineItems: state.POViewReducer.POLineItems,
        editPOView: state.SidePanReducer.EditPOView || false,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(POView);
